// Google Tag Manager tracking utilities

/**
 * Push custom event to GTM dataLayer
 */
function pushToDataLayer(eventName, eventData = {}) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData
    });
  }
}

/**
 * Track survey start (first page load)
 */
export function trackSurveyStart() {
  pushToDataLayer('startSurvey');
}

/**
 * Track registration completion (final submit)
 */
export function trackCompleteRegistration() {
  pushToDataLayer('completeRegistration');
}
